import { useContext } from 'react';
import { BannerContext } from '../BannerContext';
import injectTextblockBanners from './helpers/inject-textblock-banners';
const useBannerInsertion = component => {
  const {
    name,
    parsedTextBlock
  } = component;
  const bannerContext = useContext(BannerContext);
  const {
    banners
  } = bannerContext || {};
  if (!banners || !banners.length) return parsedTextBlock;
  const validatdParsedTextBlock = Array.isArray(parsedTextBlock) ? parsedTextBlock : [parsedTextBlock];
  return injectTextblockBanners({
    componentName: name,
    parsedTextBlock: validatdParsedTextBlock,
    bannerContext
  });
};
export default useBannerInsertion;
//# sourceMappingURL=use-banner-insertion.js.map